import { useEffect, useState, useRef } from 'react';

// Banner "Aggiornamento disponibile" — ascolta l'evento 'sw-update-available'
// emesso da serviceWorkerRegistration.js e si auto-chiude dopo 10 secondi.
export default function UpdateBanner() {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const onUpdate = () => {
      setVisible(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setVisible(false), 10000);
    };

    window.addEventListener('sw-update-available', onUpdate);
    return () => {
      window.removeEventListener('sw-update-available', onUpdate);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (!visible) return null;

  const handleReload = () => {
    // Forza il reload saltando la cache del browser
    window.location.reload();
  };

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#7c3aed',
        color: '#ffffff',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        flexWrap: 'wrap',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.9rem',
        fontWeight: 600,
        boxShadow: '0 4px 20px rgba(124,58,237,0.45)',
      }}
    >
      <span>🚀 Aggiornamento disponibile — clicca per aggiornare</span>
      <button
        onClick={handleReload}
        style={{
          background: '#ffffff',
          color: '#7c3aed',
          border: 'none',
          borderRadius: 9999,
          padding: '8px 18px',
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '0.85rem',
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Aggiorna ora
      </button>
      <button
        onClick={() => setVisible(false)}
        aria-label="Chiudi"
        style={{
          background: 'transparent',
          color: '#ffffff',
          border: 'none',
          fontSize: '1.1rem',
          cursor: 'pointer',
          padding: '0 4px',
          lineHeight: 1,
        }}
      >
        ✕
      </button>
    </div>
  );
}
